/**
 * BodyResponseUtility.js
 * Created by Vijay on 5/27/2020.
 **/

import env from '../../../../../util/env';
import {documentTypes, serviceURL} from '../../../../../util/uiconstants';

/**
 * Return body response to save into database
 * @param {Number} bodyTypeId - body type.
 * @param {String} freeText - selectedOptionId.
 * @returns {object} return data which need for save call
 **/
export const createUpdatePayload = (bodyTypeId, freeText) => {
	return {
		bodyTypeId: bodyTypeId,
		bodyResponseObject: [
			{
				bodyFreeText: freeText?.trim()
			}
		]
	};
};

/**
 * Return body response to save into database for multi select body
 * @param {Number} bodyTypeId - body type.
 * @param {array} bodyData - the data to push to the server.
 *  @returns {object} return data which need for save call
 **/
export const createUpdatePayloadForMultiSelectBody = (bodyTypeId, bodyData) => {
	let bodyResponseObject = [];
	bodyData.map((data) => {
		bodyResponseObject.push({
			bodyOptionId: data.bodyOptionId,
			isSelected: data.isChecked
		});
	});
	return {
		bodyTypeId: bodyTypeId,
		bodyResponseObject
	};
};

/**
 * Return body response to save into database
 * @param {Number} bodyId - body id.
 * @param {Number} bodyTypeId - body type.
 * @param {string} freeText - user entered text.
 * @param {string} concurrencyToken - concurrency token.
 * @returns {object} return data which need for save call
 **/
export const createUpdatePayloadForRichText = (bodyId, bodyTypeId, freeText, concurrencyToken) => {
	return {
		bodyId: bodyId,
		bodyTypeId: bodyTypeId,
		concurrencyToken: concurrencyToken,
		bodyResponseObject: [
			{
				bodyFreeText: freeText
			}
		]
	};
};

/**
 *
 * @param {Number} engagementId - engId.
 * @param {string} documentId - docId.
 * @param {Number} headerId - headerId.
 * @param {Number} sectionId - sectionId.
 * @param {Number} bodyId - bodyId.
 * @param {Number} documentTypeId - documentTypeId.
 * @returns {URL} return url
 */
export const createRequestURL = (engagementId, documentId, headerId, sectionId, bodyId, documentTypeId) => {
	if (documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
		return env.getBaseURL(serviceURL, Number(engagementId)) + `independenceForms/${documentId}/Bodies/${bodyId}`;
	} else {
		return env.getBaseURL(serviceURL, Number(engagementId)) + `forms/${documentId}/Bodies/${bodyId}`;
	}
};

export const getConcurrencyToken = (stored, body) => {
	if (stored) {
		if (stored.bodyId === body.bodyId) {
			return stored.concurrencyToken;
		} else {
			return body.concurrencyToken;
		}
	} else {
		return body.concurrencyToken;
	}
};
